import { forwardRef, type SVGProps } from 'react';

export const PersonCheckedIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function PersonCheckedIcon(props, ref) {
  return (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M14.8284 5.17157C14.0783 4.42143 13.0609 4 12 4C10.9391 4 9.92172 4.42143 9.17157 5.17157C8.42143 5.92172 8 6.93913 8 8C8 9.06087 8.42143 10.0783 9.17157 10.8284C9.92172 11.5786 10.9391 12 12 12C13.0609 12 14.0783 11.5786 14.8284 10.8284C15.5786 10.0783 16 9.06087 16 8C16 6.93913 15.5786 5.92172 14.8284 5.17157ZM13.4686 14.0672C12.9925 14.0231 12.5017 14 12 14C7.58 14 4 15.79 4 18V20H12.3414C12.1203 19.3744 12 18.7013 12 18C12 16.4955 12.5538 15.1203 13.4686 14.0672Z"
        fill="#24B25F"
        fillRule="evenodd"
      />
      <path
        d="M17.3 18.9L16.225 17.825C16.1333 17.7333 16.0167 17.6875 15.875 17.6875C15.7333 17.6875 15.6167 17.7333 15.525 17.825C15.4333 17.9167 15.3875 18.0333 15.3875 18.175C15.3875 18.3167 15.4333 18.4333 15.525 18.525L16.95 19.95C17.05 20.05 17.1667 20.1 17.3 20.1C17.4333 20.1 17.55 20.05 17.65 19.95L20.475 17.125C20.5667 17.0333 20.6125 16.9167 20.6125 16.775C20.6125 16.6333 20.5667 16.5167 20.475 16.425C20.3833 16.3333 20.2667 16.2875 20.125 16.2875C19.9833 16.2875 19.8667 16.3333 19.775 16.425L17.3 18.9ZM18 23C17.3083 23 16.6583 22.8687 16.05 22.606C15.4417 22.3433 14.9125 21.9872 14.4625 21.5375C14.0125 21.0875 13.6563 20.5583 13.394 19.95C13.1317 19.3417 13.0003 18.6917 13 18C13 17.3083 13.1313 16.6583 13.394 16.05C13.6567 15.4417 14.0128 14.9125 14.4625 14.4625C14.9125 14.0125 15.4417 13.6563 16.05 13.394C16.6583 13.1317 17.3083 13.0003 18 13C18.6917 13 19.3417 13.1313 19.95 13.394C20.5583 13.6567 21.0875 14.0128 21.5375 14.4625C21.9875 14.9125 22.3438 15.4417 22.6065 16.05C22.8692 16.6583 23.0003 17.3083 23 18C23 18.6917 22.8687 19.3417 22.606 19.95C22.3433 20.5583 21.9872 21.0875 21.5375 21.5375C21.0875 21.9875 20.5583 22.3438 19.95 22.6065C19.3417 22.8692 18.6917 23.0003 18 23Z"
        fill="#24B25F"
      />
    </svg>
  );
});
